import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useAtom } from 'jotai';
import AppLoading from '../../../components/App/AppLoading';
import AppTenantSwitchModal from '../../../components/App/AppTenantSwitchModal';
import { ROUTES } from '../../../constants';
import { useAuth } from '../../../services/auth0';
import { tempRedirectInfoState } from '../../../store/global.store';
import { getLastTenantId } from '../../../store/store.utils';

const SelectTenant = () => {
  const [loading, setLoading] = useState(true);
  const [redirectInfo, setRedirectInfo] = useAtom(tempRedirectInfoState);
  const { hasTenantInAccessToken } = useAuth();
  const onClose = () => {};
  const onOpen = () => {};

  const navigate = useNavigate();

  useEffect(() => {
    if (redirectInfo && redirectInfo.tenantId && redirectInfo.redirectUrl) {
      // Only when tenantId is set, then consume tenantId & redirectUrl
      setRedirectInfo(null);
      navigate(
        ROUTES.getSwitchTenantRoute(
          redirectInfo.tenantId,
          redirectInfo.redirectUrl,
        ),
      );
      return;
    }

    // Go straight back into the tenant used last time (it survives logout) as
    // long as this user still has access to it, instead of asking again
    const lastTenantId = getLastTenantId();
    if (lastTenantId && hasTenantInAccessToken(lastTenantId)) {
      const redirectUrl = redirectInfo?.redirectUrl || '';
      setRedirectInfo(null);
      navigate(ROUTES.getSwitchTenantRoute(lastTenantId, redirectUrl));
      return;
    }

    // Otherwise let the user select the tenant, and only consume redirectUrl
    // (This will be only when it's set via onRedirectCallback. And that is only when state.returnTo is set loginWithRedirect)
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectInfo]);

  if (loading) {
    return <AppLoading />;
  }

  return (
    <AppTenantSwitchModal
      onClose={onClose}
      onOpen={onOpen}
      isOpen
      persistentModal
      showLogout
      shouldSelectFirstOnlyTenant
    />
  );
};

export default SelectTenant;
